export default function numberSecretMask(numero) {
  if (numero && numero.length === 11)
    return `${numero[0]}${numero[1]} ****${numero[7]}${numero[8]}${numero[9]}${numero[10]}`;

  return numero || '';
}
